<template lang="pug">
  footer(:class="{ 'is-in-root': isInRoot }")
    transition(name="fade")
      .footer-container
        .background-image
          a.bm-logo(href="http://www.bancomundial.org/" target="_blank")
            img(src="@/assets/img/Logo_Banco_Mundial.png" v-if="isInRoot")
            i.ap-logo-banco-mundial(v-if="!isInRoot")
          .disclaimer(v-if="!embedded") Versión en desarrollo, los datos mostrados están en verificación.
          a.gfdrr-logo(href="https://www.gfdrr.org/" target="_blank")
            img(src="@/assets/img/Logo_GFDRR.png" v-if="isInRoot")
            i.ap-logo-gfdrr(v-if="!isInRoot")

</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { getData } from '@/utils/object.js'
import resize from '@/mixins/resize.js'

export default {
  name: 'Footer',
  mixins: [ resize ],
  computed: {
    ...mapGetters({
      state: 'interfaceState'
    }),
    embedded () {
      return getData(getData(this.$store.state.route).meta).embedded
    }
  },
  data: () => ({
    isInRoot: false
  }),
  methods: {
    ...mapActions([ 'activateControl', 'desactivateControl' ]),
    setInterfaceForMobile () {
      this.desactivateControl('movileView')
      const list = document.getElementsByClassName('back-button')
      for (let i = 0; i < list.length; i++) {
        list[i].classList.add('drop')
      }
    },
    setInterfaceForWideScreen () {
      this.activateControl('movileView')
      const list = document.getElementsByClassName('back-button')
      for (let i = 0; i < list.length; i++) {
        list[i].classList.add('bump')
      }
    }
  },

  watch: {
    isMobile (newValue) {
      setTimeout(() => {
        if (newValue) this.setInterfaceForMobile()
        else this.setInterfaceForWideScreen()
      }, 5000)
    }
  }
}
</script>

<style scoped lang="stylus">
  @import '~@/styles/variables'

  $footer-bg-color = white //#fee9c3
  $center-logo-height = $footer-height

  @media screen and (max-width: 600px)
    .footer-container .background-image
      max-width: 95% !important;
    .footer-container .background-image .disclaimer
      font-size: 0.6rem !important;
    .footer-container .background-image .bm-logo i
      font-size: 1.5rem !important;
    .footer-container .background-image .gfdrr-logo i
      font-size: 1.2rem !important;

  .footer-container
    background-color: $gray_color
    bottom 0
    height $footer-height
    position: absolute
    width 100%
    z-index: 999
    .background-image
      height 100%
      margin: 0 auto
      max-width: 80%
      display: flex
      justify-content: space-between
      align-items: center
      user-select none
      .disclaimer
        padding: $f5px
        font-family: Raleway
        font-size: $f14px
        color: white
      a
        height 100%
        display flex
        justify-content center
        align-items center
        text-decoration: none
        i
          color: white
      .bm-logo
        i
          font-size: $f33px
        img
          height 55%
          @media screen and (max-width: 400px)
            height 36%
      .gfdrr-logo
        i
          font-size: $f28px
        img
          height 50%
    .is-in-root &
      background-color $footer-bg-color
      .disclaimer
        color: rgba(0, 0, 0, .87)

  .fade-enter-active, .fade-leave-active
    transition-property: opacity max-height
    transition-duration: 0.5s
    max-height: $f500px
    will-change: opacity max-height

  .fade-enter, .fade-leave-to
    opacity: 0
    max-height: 0

</style>
